import * as React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const brandPromises = ["Eco-friendly disposal and recycling focus", "Serving Orleans, Avalon, and Fallingbrook", "Transparent pricing with no hidden fees"];
export default function IntroductionOrleansLocal() {
  return <section data-section-id="238726" id="introduction-orleans-local" className="bg-background text-foreground py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 md:items-center md:gap-8">
          
          {}
          <div className="flex flex-col justify-center">
            <h2 className="font-default text-foreground mb-6 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
              Your Local Orleans Junk Removal Experts
            </h2>
            
            <div className="font-default text-foreground/80 mb-8 space-y-4 text-base leading-relaxed md:text-lg">
              <p>
                From the quiet streets of Orleans Village to the growing communities of Avalon and Fallingbrook, we provide professional junk removal services tailored to our neighbors. We understand that clearing out space is about more than just hauling—it's about reclaiming your home.
              </p>
              <p>
                Whether you are a homeowner in South Keys or a business owner in Gloucester, our team offers same-day service to keep your property clutter-free. We prioritize responsible disposal, ensuring that usable items are donated and recyclables are processed correctly.
              </p>
            </div>

            <ul className="mb-8 space-y-3">
              {brandPromises.map((promise, i) => <li data-index={i} key={i} className="flex items-start gap-3">
                  <div className="bg-secondary/20 mt-1 flex size-5 shrink-0 items-center justify-center rounded-full">
                    <Check className="text-primary size-3.5" strokeWidth={3} />
                  </div>
                  <span className="font-default text-foreground/90 text-base font-medium">
                    {promise}
                  </span>
                </li>)}
            </ul>

            <div>
              <Button asChild size="lg" className="font-default font-semibold bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-lg shadow-md">
                <Link to="/AboutPage">
                  Learn About Our Mission
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-lg shadow-lg md:aspect-square lg:aspect-[4/3]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_junk_removal_truck.png" alt="Professional junk removal team serving the Orleans community" className="h-full w-full object-cover" loading="lazy" />
            </div>
            {}
            <div className="bg-primary/10 absolute -bottom-4 -right-4 -z-10 h-full w-full rounded-lg md:-bottom-6 md:-right-6"></div>
          </div>

        </div>
      </div>
    </section>;
}